// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import vueForm from 'vue-form'
import vueRouter from 'vue-router'
import Print from './libs/print'

Vue.config.productionTip = false;
axios.defaults.baseURL = '';
//'http://10.8.78.12:10201';

Vue.use(VueAxios, axios);
Vue.use(vueForm);
Vue.use(Print);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  watch:{
    '$route' : function(to,from,next){
      var pathArr=from.path.split('/');
      if(pathArr[1]=='add' && pathArr[4]=='see' && pathArr[5]==this.$route.params.id){
        window.location.reload();
      }

    }
  }

})



// WEBPACK FOOTER //
// ./src/main.js